// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"essay_wrapper__inFOv","para":"essay_para__iZFEb"};